import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './layout/components/header/header.component';
import { FooterComponent } from './layout/components/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { CheckoutOutletComponent } from './outlets/checkout.outlet/checkout.outlet.component';
import { PrimaryOutletComponent } from './outlets/primary.outlet/primary.outlet.component';
import { LoadingComponent } from './components/loading/loading.component';
import { EventItemComponent } from './layout/components/header/components/event-item/event-item.component';
import { FormsModule } from '@angular/forms';
import { FormInputDirective } from './directives/form-input.directive';
import { NotAvailableComponent } from './components/not-available/not-available.component';
import { GigantesOutletComponent } from './outlets/gigantes.outlet/gigantes.outlet.component';
import { UsernameOutletComponent } from './outlets/username.outlet/username.outlet.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    PrimaryOutletComponent,
    CheckoutOutletComponent,
    GigantesOutletComponent,
    UsernameOutletComponent,
    LoadingComponent,
    EventItemComponent,
    FormInputDirective,
    NotAvailableComponent,
  ],
  imports: [CommonModule, RouterOutlet, FormsModule],
  exports: [
    HeaderComponent,
    FooterComponent,
    LoadingComponent,
    FormInputDirective,
    NotAvailableComponent,
  ],
})
export class CoreModule {}
